import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Sin esto, tailwind-merge interpreta `text-h2`, `text-lead`, etc. como
// clases de color y las descarta al combinarlas con `text-secondary` y cía.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["display", "h2", "h3", "lead", "eyebrow", "mono", "index", "stat"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Genera un link de WhatsApp con un mensaje personalizado
 */
export function getWhatsAppLink(
  message?: string,
  phoneNumber: string = "543382573669"
): string {
  if (!message) {
    return `https://wa.me/${phoneNumber}`;
  }
  const encodedMessage = encodeURIComponent(message);
  return `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodedMessage}&type=phone_number&app_absent=0`;
}
